export default __webpack_public_path__ + "static/media/Group8869.9e7a69f0.svg";